import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import moment from "moment";
import PropTypes from "prop-types";

import { Button, FormControl, Grid, Paper } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import {
  CountryDropdown,
  DistrictDropdown,
  CityDropdown,
  WardDropdown,
} from "../../../partials/selectAddress";
import CountryCode from "../../countryCode";
import Dialog from "../../dialog";
import Snackbar from "../../snackbar";
import { styles } from "./styles";
import Loading from "../../loading";
import InputFileReader from "../../fileReader";
import SocialType from "../../../partials/socialType";
import { _parsePhoneNumber } from "../../../partials/validateNumber";

import SelectGender from "../../../partials/selectGender";
import SelectMultiUsedService from "../../../partials/selectMultiUsedService";
import SelectMultiInteresting from "../../../partials/selectMultiInteresting";
import InputFormat from "../../../partials/inputForm";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import "moment/locale/vi";
import "moment/locale/en-ca";
class AddCustomer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      voucher: {
        discount: 0,
      },
      selectedBranch: "",
      contentNotice: "",
      customerData: {
        customerName: "",
        customerBirthDay: moment().valueOf(),
        customerGender: "male",
        customerEmail: "",
        countryCode: this.props.defaultCountryCode || "+84",
        customerCity: "",
        customerDistrict: "",
        customerAddress: "",
        customerMobile: "",
        customerCountry: "VN",
      },
    };
    this.imgURL = "";
    this.imgFile = "";
    this.handleUploadImage = this.handleUploadImage.bind(this);
    this.handleCheck = this.handleCheck.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.defaultCountryCode !== this.props.defaultCountryCode &&
      !this.props.defaultCountryCode
    ) {
      let { customerData } = this.state;
      customerData.countryCode = nextProps.defaultCountryCode;
      this.setState({ customerData: customerData });
    }
  }

  handleUploadImage = async () => {
    if (this.InputFileReader.getFile() !== null) {
      this.loading.startLoading();
      let checkUpload = await this.props.uploadDispatch.saveStorage({
        files: this.InputFileReader.getFile(),
        code: this.state.customerData.customerMobile,
        type: "avatar-customer",
      });
      if (checkUpload.code === 1) {
        this.createCustomer(checkUpload.data.previewLink);
      } else {
        this.loading.stopLoading();
        this.props.statusCreate("03", checkUpload.message);
      }
    } else if (this.InputFileReader.getSrc() !== null)
      this.createCustomer(this.InputFileReader.getSrc());
    else this.createCustomer();
  };
  createCustomer = async (customerImage = null) => {
    const { serviceSetting } = this.props;
    let dataCustomer = this.state.customerData;
    dataCustomer.customerImage = customerImage;
    dataCustomer.customerBirthDay =
      dataCustomer.customerBirthDay || moment().valueOf();
    dataCustomer.code =
      dataCustomer.code ||
      `${serviceSetting.prefixCustomer}${serviceSetting.totalCustomer + 1}`;
    this.loading.startLoading();
    let check = await this.props.customerDispatch.createCustomer(dataCustomer);
    if (check && check.code) {
      this.props.statusCreate("01");
      this.props.customerDispatch.getChart();
    } else {
      if (check.error === 1109) this.props.statusCreate("1109");
      else this.props.statusCreate("02", check.message);
    }
    this.loading.stopLoading();
  };
  handleChange = (name, value) => {
    let { customerData } = this.state;
    if (name === "customerBirthDay")
      customerData[name] =
        value && value._isAMomentObject ? value.valueOf() : moment().valueOf();
    else customerData[name] = value;
    this.setState({ customerData });
  };

  removeAscent(str) {
    if (str === null || str === undefined) return str;
    str = str.toLowerCase();
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    str = str.replace(/đ/g, "d");
    return str;
  }

  handleCheck() {
    let { t } = this.props;
    let data = this.state.customerData;
    let validPhone = _parsePhoneNumber(data.countryCode, data.customerMobile)
      .isValid;
    if (!data.customerName || !data.customerMobile || !data.countryCode) {
      this.mSnackbar.handleClick(
        t("customer_addcustomer_please_fill_in_this_form"),
        "info"
      );
    } else if (!validPhone) {
      this.mSnackbar.handleClick(
        t("customer_addcustomer_phone_number_is_not_valid"),
        "info"
      );
    } else {
      this.handleUploadImage();
    }
  }

  onChangeSelect = (e) => {
    let customerData = this.state.customerData;

    customerData[e.target.name] = e.target.value;
    this.setState({ customerData });
  };
  snackbar = (mess, type) => {
    this.mSnackbar.handleClick(mess, type);
  };

  handleGetValueUsedService = (value) => {
    let { customerData } = this.state;
    customerData["useServices"] = value;
    this.setState({ customerData });
  };

  handleGetValueInteresting = (value) => {
    let { customerData } = this.state;
    customerData["interesting"] = value;
    this.setState({ customerData });
  };
  render() {
    const { classes, allMenuItem = [], t, i18n, serviceSetting } = this.props;
    const { customerData } = this.state;
    return (
      <MuiPickersUtilsProvider
        libInstance={moment}
        utils={MomentUtils}
        locale={i18n.language === "vn" ? "vi" : "en"}
      >
        <Paper className={classes.root}>
          <Dialog
            onRef={(dialog) => (this.mDialog = dialog)}
            disagree={t("customer_addcustomer_cancel")}
            agree={t("customer_addcustomer_add")}
            title={t("customer_addcustomer_confirm")}
            content={t("customer_addcustomer_add_new_customer")}
            action={this.handleUploadImage}
          />
          <Dialog
            onRef={(dialog) => (this.dialogNotice = dialog)}
            disagree={t("customer_addcustomer_cancel")}
            // agree="Create"
            title={t("Notice")}
            content={this.state.contentNotice}
            // action={this.handleUploadImage}
          />
          <Loading onRef={(id) => (this.loading = id)} />
          <Snackbar onRef={(snackbar) => (this.mSnackbar = snackbar)} />
          <form className={classes.container} noValidate autoComplete="off">
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12}>
                <InputFileReader
                  onRef={(id) => (this.InputFileReader = id)}
                  style={classes}
                  selectStorageMode={true}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <Grid container spacing={3}>
                  <Grid item xs={12} sm={4}>
                    <Grid container spacing={3} alignItems="flex-end">
                      <Grid item xs={6} sm={4}>
                        <CountryCode
                          code={customerData.countryCode}
                          handleCountryCode={this.handleChange}
                        />
                      </Grid>
                      <Grid item xs={6} sm={8}>
                        <InputFormat
                          required
                          label={t("customer_addcustomer_mobile")}
                          name="customerMobile"
                          value={customerData.customerMobile}
                          onChange={(event) =>
                            this.handleChange(
                              "customerMobile",
                              event.target.value
                            )
                          }
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <InputFormat
                      required
                      label={t("customer_addcustomer_name")}
                      name="customerName"
                      value={customerData.customerName}
                      onChange={(event) =>
                        this.handleChange("customerName", event.target.value)
                      }
                      inputProps={{
                        maxLength: 100,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FormControl className={classes.formControl}>
                      <KeyboardDatePicker
                        autoOk
                        disableFuture={true}
                        name="dob"
                        inputVariant="outlined"
                        label={t("customer_addcustomer_birthDay")}
                        format="DD/MM/YYYY"
                        value={customerData.customerBirthDay}
                        views={["year", "month", "date"]}
                        onChange={(date) =>
                          this.handleChange("customerBirthDay", date)
                        }
                        cancelLabel={t("date_picker_cancel")}
                        okLabel={t("date_picker_ok")}
                      />
                    </FormControl>
                    {/* <DatePicker
                    renderInput={(props) => (
                      <InputFormat
                        required
                        InputProps={{
                          ...props,
                          classes: {
                            root: classes.customRoot,
                            input: classes.customInput,
                          },
                        }}
                        label={t("customer_addcustomer_birthDay")}
                      />
                    )}
                    timeFormat={false}
                    dateFormat="DD/MM/YYYY"
                    onChange={(date) =>
                      this.handleChange("customerBirthDay", date)
                    }
                    value={customerData.customerBirthDay}
                    defaultValue={moment().valueOf()}
                    locale={i18n.language === "vn" ? "vi" : "en"}
                  /> */}
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={12}>
                <Grid container spacing={3} alignItems="flex-end">
                  <Grid item xs={12} sm={4}>
                    <InputFormat
                      label="Code"
                      name="code"
                      value={
                        customerData.code ||
                        `${serviceSetting.prefixCustomer}${
                          serviceSetting.totalCustomer + 1
                        }`
                      }
                      onChange={(event) =>
                        this.handleChange("code", event.target.value)
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <SelectGender
                      name="customerGender"
                      label={t("customer_addcustomer_gender")}
                      value={customerData.customerGender}
                      onChange={(event) =>
                        this.handleChange("customerGender", event.target.value)
                      }
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <InputFormat
                      label="Email"
                      name="customerEmail"
                      value={customerData.customerEmail}
                      onChange={(event) =>
                        this.handleChange("customerEmail", event.target.value)
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={12}>
                <Grid container spacing={3} alignItems="flex-end">
                  <Grid item xs={12} sm={4}>
                    <SocialType
                      label="Social Type"
                      name="socialType"
                      value={customerData.socialType}
                      onChange={(event) =>
                        this.handleChange("socialType", event.target.value)
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <InputFormat
                      label="Social ID"
                      name="socialId"
                      value={customerData.socialId}
                      onChange={(event) =>
                        this.handleChange("socialId", event.target.value)
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <InputFormat
                      label="Social Link"
                      name="socialLink"
                      value={customerData.socialLink}
                      onChange={(event) =>
                        this.handleChange("socialLink", event.target.value)
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} sm={12}>
                <Grid container spacing={3} alignItems="flex-end">
                  <Grid item xs={12} sm={4}>
                    <CountryDropdown
                      label={t("customer_addcustomer_country")}
                      name="customerCountry"
                      priorityOptions={["VN"]}
                      whitelist={["VN", "US"]}
                      valueType="short"
                      blankOptionLabel={t("country")}
                      defaultOptionLabel={t("select_country")}
                      onChange={this.onChangeSelect}
                      value={customerData.customerCountry}
                      showDefaultOption={true}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <CityDropdown
                      label={
                        customerData.customerCountry == "US"
                          ? t("customer_addcustomer_state")
                          : t("customer_addcustomer_city")
                      }
                      country={customerData.customerCountry}
                      value={customerData.customerCity}
                      blankOptionLabel={t("city")}
                      defaultOptionLabel={t("select_city")}
                      name="customerCity"
                      onChange={this.onChangeSelect}
                      countryValueType="short"
                      showDefaultOption={true}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <DistrictDropdown
                      label={t("customer_addcustomer_district")}
                      country={customerData.customerCountry}
                      region={customerData.customerCity}
                      value={customerData.customerDistrict}
                      disabled={customerData.customerCountry === "US"}
                      blankOptionLabel={t("district")}
                      defaultOptionLabel={t("select_district")}
                      name="customerDistrict"
                      countryValueType="short"
                      onChange={this.onChangeSelect}
                      showDefaultOption={true}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <WardDropdown
                      label={t("ward")}
                      country={customerData.customerCountry}
                      city={customerData.customerCity}
                      region={customerData.customerDistrict}
                      value={customerData.customerWard}
                      disabled={customerData.customerCountry === "US"}
                      blankOptionLabel={t("ward")}
                      defaultOptionLabel={t("select_ward")}
                      name="customerWard"
                      countryValueType="short"
                      onChange={this.onChangeSelect}
                      showDefaultOption={true}
                    />
                  </Grid>
                  <Grid item xs={12} sm={8}>
                    <InputFormat
                      label={t("customer_addcustomer_address")}
                      name="customerAddress"
                      value={customerData.customerAddress}
                      onChange={(event) =>
                        this.handleChange("customerAddress", event.target.value)
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} sm={12}>
                <Grid container spacing={3} alignItems="flex-end">
                  <Grid item xs={12} sm={12}>
                    <SelectMultiUsedService
                      label={t("customer_useSerives")}
                      placeholder={t("customer_useSerives_placeholder")}
                      name="useServices"
                      handleGetValue={this.handleGetValueUsedService}
                      suggestions={allMenuItem.map((e) => {
                        return {
                          label: e.title,
                          value: {
                            menuId: e.menuId,
                            menuItemId: e.itemCode,
                            totalMoney: e.price,
                            label: e.title,
                            quantity: 1,
                          },
                        };
                      })}
                      defaultValue={customerData.useServices}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <SelectMultiInteresting
                      label={t("customer_interesting")}
                      placeholder={t("customer_useSerives_placeholder")}
                      name="interesting"
                      handleGetValue={this.handleGetValueInteresting}
                      suggestions={
                        allMenuItem.map((e) => {
                          return {
                            label: e.title,
                            value: {
                              menuId: e.menuId,
                              menuItemId: e.itemCode,
                              totalMoney: e.price,
                              label: e.title,
                              // id: e.itemCode,
                              // type: "memuItem",
                              // totalMoney: e.price,
                              // label: e.title,
                            },
                          };
                        })
                        // .concat(
                        //   allVoucher.map(e => {
                        //     return {
                        //       label: "Voucher: " + e.code,
                        //       value: {
                        //         id: e.code,
                        //         type: "voucher"
                        //       }
                        //     };
                        //   })
                        // )
                      }
                      defaultValue={customerData.interesting}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid container spacing={12} justify="flex-end">
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.button}
                  onClick={() => this.handleCheck()}
                >
                  {t("customer_addcustomer_create_customer")}
                </Button>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </MuiPickersUtilsProvider>
    );
  }
}

AddCustomer.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};
const mapState = (state) => ({
  allMenuItem: state.serviceMenuItem.allMenuItem || [],
  defaultCountryCode: state.setting.setting
    ? state.setting.setting.defaultCountryCode
    : "+84",
  serviceSetting: state.serviceSetting.serviceSetting,
});

const mapDispatch = (dispatch) => ({
  customerDispatch: dispatch.customer,
  uploadDispatch: dispatch.upload,
});

export default connect(
  mapState,
  mapDispatch
)(
  translate("translations")(
    withStyles(styles, { withTheme: true })(AddCustomer)
  )
);
